import { render } from "./PromOrder.vue?vue&type=template&id=7ced88a2&scoped=true"
import script from "./PromOrder.vue?vue&type=script&lang=js"
export * from "./PromOrder.vue?vue&type=script&lang=js"

import "./PromOrder.vue?vue&type=style&index=0&id=7ced88a2&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ced88a2"]])

export default __exports__